import DocIndex from './DocIndex/DocIndex'
import BasicCard from './Widgets/BasicCard';
import CardTiles from './Widgets/CardTiles';
import CardTab from './Widgets/CardTab';
import Tables from './Widgets/Tables';
import Forms from './Widgets/Forms';
import ApexCharts from './Charts/ApexCharts/ApexCharts';
import PeityCharts from './Charts/PeityCharts/PeityCharts';
import DataTables from './Plugins/DataTables/DataTables';
import Flatpickrc from './Plugins/Flatpickr/Flatpickr';
import InputmaskPlugin from './Plugins/Inputmask/InputmaskPlugin';
import Jsvectormap from './Plugins/Jsvectormap/Jsvectormap';
import SortableJS from './Plugins/SortableJS/SortableJS';
import Sweetalert2 from './Plugins/Sweetalert2/Sweetalert2';
import Tinyslider from './Plugins/Tinyslider/Tinyslider';
import ToastUICalendar from './Plugins/ToastUICalendar/ToastUICalendar';
import Summernote from './Plugins/Summernote/Summernote';
import BootstrapIcon from './FontIcon/BootstrapIcon/BootstrapIcon';
import CountryFlagsIcon from './FontIcon/CountryFlagsIcon/CountryFlagsIcon';
import FontawesomeIcon from './FontIcon/FontawesomeIcon/FontawesomeIcon';
import LinearIcon from './FontIcon/LinearIcon/LinearIcon';
import WeatherIcon from './FontIcon/WeatherIcon/WeatherIcon';
import Accordion from './BootstrapUI/Accordion/Accordion';
import Alerts from './BootstrapUI/Alerts/Alerts';
import UserAvatar from './BootstrapUI/UserAvatar/UserAvatar';
import Badges from './BootstrapUI/Badges/Badges';
import Breadcrumb from './BootstrapUI/Breadcrumb/Breadcrumb';
import Buttons from './BootstrapUI/Buttons/Buttons';
import Cards from './BootstrapUI/Cards/Cards';
import Carousel from './BootstrapUI/Carousel/Carousel';
import Collapse from './BootstrapUI/Collapse/Collapse';
import Dropdowns from './BootstrapUI/Dropdowns/Dropdowns';
import Listgroup from './BootstrapUI/Listgroup/Listgroup';
import Modal from './BootstrapUI/Modal/Modal';
import Navbar from './BootstrapUI/Navbar/Navbar';
import Navstabs from './BootstrapUI/Navstabs/Navstabs';
import Offcanvas from './BootstrapUI/Offcanvas/Offcanvas';
import Pagination from './BootstrapUI/Pagination/Pagination';
import Placeholders from './BootstrapUI/Placeholders/Placeholders';
import PopoversContent from './BootstrapUI/Popovers/PopoversContent';
import Progressbar from './BootstrapUI/Progressbar/Progressbar';
import Spinners from './BootstrapUI/Spinners/Spinners';
import Toasts from './BootstrapUI/Toasts/Toasts';

export const generalTitleMapping = {
    /* // x---------------------------------x General Title Mapping Section x---------------------------------x */
    "/docs/documentation": "Index",
    "/docs/widgets-basic-card": "BasicCard",
    "/docs/widgets-card-tiles": "CardTiles",
    "/docs/widgets-card-tab": "CardTab",
    "/docs/widgets-tables": "Tables",
    "/docs/widgets-forms": "Forms",
    "/docs/apex-chart": "ApexChart",
    "/docs/peity": "PeityChart",
    "/docs/datatables": "DataTable",
    "/docs/flatpickr": "Flatpickr",
    "/docs/inputmask": "Inputmask",
    "/docs/jsvectormap": "Jsvectormap",
    "/docs/sortablejs": "Sortablejs",
    "/docs/sweetalert2": "Sweetalert2",
    "/docs/tiny-slider": "TinySlider",
    "/docs/react-big-calendar": "Calendar",
    "/docs/summernote": "Summernote",
    "/docs/bootstrap-icon": "BootstrapIcon",
    "/docs/flag-icon": "FlagIcon",
    "/docs/fontawesome-icon": "FontawesomeIcon",
    "/docs/linear-icon": "LinearIcon",
    "/docs/weather-icon": "WeatherIcon",
}
export const bootstrapTitleMapping = {
    /* // x---------------------------------x Bootstrap Title Mapping Section x---------------------------------x */
    "/docs/accordion": "Accordion",
    "/docs/alerts": "Alerts",
    "/docs/avatar": "Avatar",
    "/docs/badges": "Badges",
    "/docs/breadcrumb": "Breadcrumb",
    "/docs/buttons": "Buttons",
    "/docs/cards": "Cards",
    "/docs/carousel": "Carousel",
    "/docs/collapse": "Collapse",
    "/docs/dropdowns": "Dropdowns",
    "/docs/listgroup": "Listgroup",
    "/docs/modal": "ModalPopup",
    "/docs/navbar": "Navbar",
    "/docs/navstabs": "NavsTabs",
    "/docs/offcanvas": "Offcanvas",
    "/docs/pagination": "Pagination",
    "/docs/placeholders": "Placeholders",
    "/docs/popovers": "Popovers",
    "/docs/progress": "Progressbar",
    "/docs/spinners": "Spinners",
    "/docs/toasts": "Toasts",
};

export const docComponents = {

    /* // x---------------------------------x General Components Mapping Section x---------------------------------x */
    Index: <DocIndex />, // Documentation Index Component  
    BasicCard: <BasicCard />, // Basic card Component
    CardTiles: <CardTiles />, // Widgets card tiles Component
    CardTab: <CardTab />, // Card tab Component
    Tables: <Tables />, // Widgets tables Component
    Forms: <Forms />, // Widgets Form Component
    ApexChart: <ApexCharts />, // Apex Charts Component
    PeityChart: <PeityCharts />, // PeityCharts Component
    DataTable: <DataTables />, // DataTables Component
    Flatpickr: <Flatpickrc />, // Flatpickr Component
    Inputmask: <InputmaskPlugin />, // Inputmask Component
    Jsvectormap: <Jsvectormap />, // Jsvectormap Component
    Sortablejs: <SortableJS />, // Sortablejs Component
    Sweetalert2: <Sweetalert2 />, // Sweetalert2 Component
    TinySlider: <Tinyslider />, // TinySlider Component
    Calendar: <ToastUICalendar />, // Calendar Component
    Summernote: <Summernote />, // Summernote Component
    BootstrapIcon: <BootstrapIcon />, // BootstrapIcon Component
    FlagIcon: <CountryFlagsIcon />, // FlagIcon Component
    FontawesomeIcon: <FontawesomeIcon />, // FontawesomeIcon Component
    LinearIcon: <LinearIcon />, // LinearIcon Component
    WeatherIcon: <WeatherIcon />, // WeatherIcon Component

    /* // x---------------------------------x Bootstrap Components Mapping Section x---------------------------------x */
    Accordion: <Accordion />, // Accordion Component
    Alerts: <Alerts />, // Alerts Component
    Avatar: <UserAvatar />, // Avatar  Component 
    Badges: <Badges />, // Badges Component
    Breadcrumb: <Breadcrumb />, // Breadcrumb Component
    Buttons: <Buttons />, // Buttons Component
    Cards: <Cards />, // Cards Component
    Carousel: <Carousel />, // Carousel Component
    Collapse: <Collapse />, // Collapse Component
    Dropdowns: <Dropdowns />, // Dropdowns Component
    Listgroup: <Listgroup />, // Listgroup Component
    ModalPopup: <Modal />, // ModalPopup Component
    Navbar: <Navbar />, // Navbar Component
    NavsTabs: <Navstabs />, // NavsTabs Component
    Offcanvas: <Offcanvas />, // Offcanvas Component
    Pagination: <Pagination />, // Pagination Component
    Placeholders: <Placeholders />, // Placeholders Component
    Popovers: <PopoversContent />, // Popovers Component
    Progressbar: <Progressbar />, // Progressbar Component
    Spinners: <Spinners />, // Spinners Component
    Toasts: <Toasts />, // Toasts Component
};

